import { ISelectLabel } from "@ds/ds-snam/dist/models/select";
import { Checkbox, Select } from "@ds/ds-snam/react";
import { CalendarDayServiceType, ICalendarDialogForm, ICalendarDialogFormData, ICalendarEvent, IContractBookSlot } from "dataModels/b2b";
import { getContractsSlot } from "net/b2b";
import React, { forwardRef, useCallback, useEffect, useImperativeHandle, useRef, useState } from "react";
import { Col, Row } from "react-grid-system";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { UICommand, DATE_FORMAT, TIME_FORMAT, DsLayout, AppUserRole, IAppUserProfile } from "shared/constants";
import { requestPending, requestPristine } from "state/reducer/requestStatusSlice";
import _ from 'lodash';
import moment from "moment";
import { dsSelectHandler } from "shared/utils/dsComponentUtils";
import { RootState } from "state/appStore";
import { AppUser } from "ooAuth2/appUser";
import useAppUser from "hooks/useAppUser";

interface SlotBookingFormProps {
    //submitButtonLabel:string,
    //dismissButtonLabel:string,
    command: UICommand,
    selectedEvent: ICalendarEvent | undefined,
    isCloning:boolean
    //onSave:()=>void,
    //onClose:()=>void,
}

const SlotBookingForm = forwardRef<ICalendarDialogForm, SlotBookingFormProps>((props, ref) => {

    const defaultData: ICalendarDialogFormData = {
        slotId: props.selectedEvent!.id,
        service: -1,
        clientId: '',
        contractId: ''
    }


    const [formData, setFormData] = useState<ICalendarDialogFormData>(defaultData);
    const [contractSlot, setContractSlot] = useState<IContractBookSlot[] | undefined>()
    const [serviceList, setServiceList] = useState<ISelectLabel[] | undefined>();
    const [contractList, setContractList] = useState<IContractBookSlot[] | undefined>();
    const [isAvailable, setIsAvailable] = useState(false);
    const layoutMode = useSelector((state:RootState)=>{
        return state.dsLayout.mode;
    })

    const { t, i18n } = useTranslation(["b2b", "app"]);

    const dispatch = useDispatch();
    const localRef = useRef<HTMLDivElement>(null);
    useImperativeHandle(ref, () => ({
        getFormValues: () => {
            return formData //qua ritornare il formdata
        }
    }));

    /*const setFormDataValue = (label: keyof ICalendarDialogFormData, value: string | number) => {
        let currentFormData = {...formData};
        if ((label === 'clientId' || label === 'contractId') && typeof value === 'string') {
            currentFormData[label] = value;
        }else if (label === 'service' && typeof value === 'number') {
            currentFormData[label] = value;
        }
        setFormData(currentFormData);
    }*/
    const setFormDataValue = (label: keyof ICalendarDialogFormData, value: string | number | boolean) => {
        setFormData((prevFormData) => {
            let updatedFormData = { ...prevFormData };
            if ((label === 'clientId' || label === 'contractId') && typeof value === 'string') {
                updatedFormData[label] = value;
            } else if (label === 'service' && typeof value === 'number') {
                updatedFormData[label] = value;
            } else if (label === 'bioFlagStatus' && typeof value === 'boolean') {
                updatedFormData.bioFlagStatus = value;
            }
            return updatedFormData;
        });
    };


    const getbaysAvailables = () => {
        let bayes:string[]|undefined = props.selectedEvent?.extendedProps?.baysAvailable;
        let bayesStr = ''
        for (let i in bayes) {
            bayesStr = bayesStr + t('calendar.popups.slotBooking.7') + ' ' + bayes[Number(i)];
            if (Number(i) < bayes.length - 1) {
                bayesStr = bayesStr + ', ';
            }
        }
        return bayesStr;
    }

    const loadServices = () => {
        if(contractSlot){
            //let servicesList = props.selectedEvent?.extendedProps?.services
            const selectedSlot = contractSlot.find(slot => slot.value === formData.clientId);
            
            if(selectedSlot && selectedSlot.contractServices){
                const contractServices = selectedSlot!.contractServices.find(cs => cs.contractId === formData.contractId);
                const servicesList = contractServices ? contractServices.services : [];
                let myServices: ISelectLabel[] = [];

                for (let i in servicesList) {
                    switch (servicesList[Number(i)]) {
                        case (CalendarDayServiceType.TRUCK_LOADING): //0
                            myServices.push({ id: '0', label: 'Truck loading', selected: false })
                            break;
                        case (CalendarDayServiceType.COOL_DOWN_TL): //1
                            myServices.push({ id: '1', label: 'Cool down', selected: false })
                            break;
                        case (CalendarDayServiceType.GAS_UP_COOL_DOWN_TL): //2
                            myServices.push({ id: '2', label: 'Gas up + Truck Load', selected: false })
                            break;
                        case (CalendarDayServiceType.SEMI_TRAILER_APPROVAL_TL): //3
                            myServices.push({ id: '3', label: 'Semi trailer approval', selected: false })
                            break;
                        case (CalendarDayServiceType.DRIVER_APPROVAL_TL): //4
                            myServices.push({ id: '4', label: 'Driver approval', selected: false })
                            break;
                        case (CalendarDayServiceType.SEMI_TRAILER_DRIVER_APPROVAL_TL): //5
                            myServices.push({ id: '5', label: 'Semi trailer approval + Driver approval', selected: false })
                            break;
                        case (CalendarDayServiceType.ISO_CONTAINER_APPROVAL_TL): //6
                            myServices.push({ id: '6', label: 'Iso container approval', selected: false })
                            break;
                        case (CalendarDayServiceType.ISO_CONTAINER_DRIVER_APPROVAL_TL): //7
                            myServices.push({ id: '7', label: 'Iso container approval + driver approval', selected: false })
                            break;
                        default:
                            break;
                    }
                }
                if(myServices.length){
                    myServices[0].selected = true;
                }
                setServiceList(myServices);

            }
            
        }
        
    }

    useEffect(()=>{
        if(serviceList /*&& serviceList.length*/){
            let currentFormData = formData;
            
            if(serviceList.length!==0){
                currentFormData.service = Number(serviceList[0].id);
            }else{
                currentFormData.service = -1;
            }
            setFormData(currentFormData);
            
        }
    },[serviceList])

    const appUser: AppUser | undefined = useAppUser();
    const appUserRole: AppUserRole | undefined = appUser?.getRole();
    const appUserProfile: IAppUserProfile | undefined = appUser?.userProfile;
    const loadData = useCallback(() => {
        dispatch(requestPending());
        getContractsSlot(props.selectedEvent!.id)
            .then((response: IContractBookSlot[]) => {
                if (response.length) {
                    if(appUserRole===AppUserRole.CUSTOMER){
                        //se sono customer ho il mio id, voglio togliere tutti gli oggetti che non mi riguardano
                        const myId = appUser?.getCustomers()![0];
                        response = response.filter(slot => slot.value === myId!.toString());
                    }
                    if (response.length) {
                        response[0].selected = true;
                        setContractSlot(response);
                        setFormDataValue('clientId', response[0].value!);
                    }
                }
            })
            .catch(error => {
                console.log(error);
            })
            .finally(() => {
                dispatch(requestPristine());
            })
    }, [dispatch]);

    useEffect(() => {
        loadServices();
    },[formData.contractId])


    useEffect(() => {
        //setFormDataValue('clientId', '');
        loadData();
        return ()=>{
            setFormDataValue('clientId', '');
            setFormDataValue('contractId', '');
        };
    }, [loadData]);

    useEffect(() => {
        //console.log("clientId: " + formData.clientId)
        const selectedClientContracts = _.find(contractSlot, (slot: IContractBookSlot) => {
            return slot.value === formData.clientId
        })?.contracts;
        if (selectedClientContracts && selectedClientContracts.length) {
            //selectedClientContracts[0].selected = true;
            //setIsAvailable(selectedClientContracts[0].available!);
            //setFormDataValue('contractId', selectedClientContracts[0].value!);

            dsSelectHandler(selectedClientContracts as ISelectLabel[], selectedClientContracts[0]);
            setIsAvailable(selectedClientContracts[0]?.available!);
            setFormDataValue('contractId', selectedClientContracts[0].value!);
            setFormDataValue('bioFlagStatus', selectedClientContracts[0].bioFlagStatus ?? false);
            setContractList(selectedClientContracts);        
        }
    }, [formData.clientId]);

    const selectedContract = contractList?.find(contract => contract.value === formData.contractId);

    /*useEffect(() => {
        if(contractList!==undefined){
            let currentFormData = {...formData};
            currentFormData.contractId = contractList[0].value;
            setFormData(currentFormData);
        }
    }, [contractList]);*/


    return (
        <>   
            <div ref={localRef}>
                <div slot="title">
                    <h2 className="ff-ubuntu ff-title-s ff-bold" style={{ margin: "0 auto", width: 'fit-content',color:layoutMode===DsLayout.DARK_MODE?"white":"black" }} id="overlay-title">
                        
                        {props.isCloning===false ? 
                            t('calendar.popups.slotBooking.0') /*Confermi di voler prenotare lo slot?*/
                            :
                            t('booking.cloneSlot.6')
                        } 
                    </h2>
                    {props.isCloning===true && <p style={{ margin: "0 auto",textAlign:'center',marginTop:'20px' }}>{t('booking.cloneSlot.7')}</p>}
                </div>

                <div slot="text" style={{ background: layoutMode===DsLayout.DARK_MODE?"#081C3E":'white', margin: '15px', paddingLeft: '5%', paddingRight: '5%', marginTop: '10px',color:layoutMode===DsLayout.DARK_MODE?"white":"black" }}>
                    <Row>
                        <Col xs={12} md={4} style={{marginBottom:'12px'}}>
                            <h3>{t('calendar.popups.slotBooking.1')} {/*Dettagli slot*/}</h3>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} md={6} style={{marginBottom:'12px'}}>
                            <p style={{ fontSize: '90%' }}>{t('calendar.popups.slotBooking.2')} {/*Data*/}</p>
                            <p style={{ fontSize: '100%' }}>{
                                moment(props.selectedEvent?.start).format(DATE_FORMAT)
                            }</p>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} md={6} style={{marginBottom:'12px'}}>
                            <p style={{ fontSize: '90%' }}>{t('calendar.popups.slotBooking.3')} {/*Orario di inizio*/}</p>
                            <p style={{ fontSize: '100%' }}>{
                                moment(props.selectedEvent?.start).format(TIME_FORMAT)
                            }</p>
                        </Col>
                        <Col xs={12} md={6} style={{marginBottom:'12px'}}>
                            <p style={{ fontSize: '90%' }}>{t('calendar.popups.slotBooking.4')} {/*Orario di fine*/}</p>
                            <p style={{ fontSize: '100%' }}>{
                                moment(props.selectedEvent?.end).format(TIME_FORMAT)
                        }</p>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} md={6} style={{marginBottom:'12px'}}>
                            <p style={{ fontSize: '90%' }}>{t('calendar.popups.slotBooking.5')} {/*Slot disponibili*/}</p>
                            <p style={{ fontSize: '100%' }}>{props.selectedEvent?.extendedProps?.slotsAvailable}</p>
                        </Col>
                        <Col xs={12} md={6} style={{marginBottom:'12px'}}>
                            <p style={{ fontSize: '90%' }}>{t('calendar.popups.slotBooking.6')} {/*Baie disponibili*/}</p>
                            <p style={{ fontSize: '100%' }}>{getbaysAvailables()}</p>
                        </Col>
                    </Row>
                    {props.isCloning===false && <>
                    <Row>
                        <div style={{ border: '1px solid grey', width: '100%', marginLeft: '25px', marginRight: '25px', marginBottom: '10px' }}></div>
                    </Row>
                    <Row style={{ marginBottom: '10px' }}>
                        <Col xs={12} md={6}>
                            <Select
                                id="clientSelection"
                                menuPlaceholder=""
                                hasIcon={false}
                                menuOptions={contractSlot === undefined ? [] : contractSlot}
                                menuLabel={t('calendar.popups.slotBooking.9')} //"Cliente*"
                                menuId="select-client"
                                isDisabled={contractSlot === undefined}
                                selectStatus="default"
                                onOptionSelection={(event: Event) => {
                                    const selection:ISelectLabel = (event as CustomEvent).detail.option;
                                    dsSelectHandler(contractSlot!, selection)
                                    setFormDataValue('clientId', selection!.value!);
                                }}
                            ></Select>
                        </Col>
                        <Col xs={12} md={6}>
                            <Select
                                id="contactSelection"
                                menuPlaceholder=""
                                hasIcon={false}
                                menuOptions={contractList === undefined ? [] : contractList} //TODO
                                menuLabel={t('calendar.popups.slotBooking.10')} //"Contratto*"
                                menuId="select-contract"
                                isDisabled={contractList === undefined}
                                selectStatus={isAvailable ? "default" : "error"}
                                onOptionSelection={(event: Event) => {
                                    const selectedOption = (event as CustomEvent).detail.option;
                                    const selectedContract = contractList?.find(contract => contract.value === selectedOption.value);
                                    dsSelectHandler(contractList as ISelectLabel[], selectedOption);
                                    //const contractId = selectedOption.id;
                                    /*for (let i in contractList) {
                                        const thisObj: IContractBookSlot = contractList[Number(i)];
                                        thisObj.selected = thisObj.id === contractId;
                                    }*/
                                    setIsAvailable(selectedContract?.available ?? selectedOption.available);
                                    setFormDataValue('contractId', selectedOption.value);
                                    setFormDataValue('bioFlagStatus', selectedContract?.bioFlagStatus ?? false);
                                }}
                            ></Select>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} md={6}>
                            <Select
                                id="serviceSelection"
                                menuPlaceholder=""
                                hasIcon={false}
                                menuOptions={serviceList === undefined? [] : serviceList} //TODO
                                menuLabel={t('calendar.popups.slotBooking.8')} //"Servizio*"
                                menuId="select-id"
                                isDisabled={serviceList === undefined || serviceList.length === 0}
                                selectStatus="default"
                                onOptionSelection={(event: Event) => {
                                    const selectedOption = (event as CustomEvent).detail.option;
                                    dsSelectHandler(serviceList as ISelectLabel[], selectedOption);
                                    setFormDataValue('service', Number(selectedOption.id));
                                }}
                            ></Select>
                        </Col>
                        <Col xs={12} md={6} style={{ display: 'flex', alignItems: 'center' }}>
                            <Checkbox
                                checkboxId="BioLNG"
                                checkboxStatus="default"
                                checkboxLabel="Bio LNG"
                                elementResetPair=""
                                isDisabled={selectedContract?.bioFlagDisabled ?? true}
                                isChecked={formData.bioFlagStatus ?? selectedContract?.bioFlagStatus ?? false}
                                isRequired={false}
                                onCheckboxChange={(event:Event)=>{
                                    const isChecked = (event as CustomEvent).detail.checkbox.checked;
                                    setFormDataValue('bioFlagStatus', isChecked);
                                }}>
                            </Checkbox>
                        </Col>
                    </Row>
                    </>}
                    {!isAvailable && <p style={{ fontFamily: 'Lato, Lato-local, sans-serif', color: 'red' }}>{t('calendar.popups.slotBooking.11')}</p>}
                </div>
            </div>
        </>
    );
});
export default SlotBookingForm;